import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { ModalDirective } from 'ng-uikit-pro-standard';

import { SecurityService } from "src/app/shared/services/security.service";
import { ConsoleService } from "src/app/shared/services/console.service";
import { FormValidatorsService } from "src/app/shared/services/form-validators.service";
import { ToastService } from 'ng-uikit-pro-standard';
import { EquivalenciaProductoService } from 'src/app/services/equivalencia-producto.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { PaginationContext } from "src/app/shared/object/pagination_context.model";
import * as _ from "lodash";

@Component({
  selector: 'app-modal-seleccionar-producto-proveedor',
  templateUrl: './modal-seleccionar-producto-proveedor.component.html',
  styleUrls: ['./modal-seleccionar-producto-proveedor.component.scss'],
  providers: [SecurityService]
})
export class ModalSeleccionarProductoProveedorComponent implements OnInit {

  // Modales
  @ViewChild('seleccionarProducto', { static: true })
  seleccionarProductModal: ModalDirective;

  @Output() onSelect: EventEmitter<any> = new EventEmitter<any>();
  @Output() onNotFound: EventEmitter<any> = new EventEmitter<any>();

  @Input() showInfoProveedorInactivoBloqueado: boolean = false
  @Input() enviaRutProveedor: string;

  // Data & tmp
  public rutEmpresa: number
  public sucursalCodigo: number

  private log: any

  // Form
  formHeader: FormGroup


  optionsCondPago: Array<any> = [];
  optionsTipoFact: Array<any> = [];
  optionsTipoItem: Array<any> = [];
  optionsUndMed: Array<any> = [];
  optionsSelect: Array<any> = [];
  optionsImp: Array<any> = [];
  optionsCategoria: Array<any> = [];
  optionsFamilia: Array<any> = [];

  Product_paginationContext: PaginationContext = new PaginationContext();
  Productos_lista: Array<any> = null;

  loading: boolean = false;
  showTable: boolean = false;
  loadSpinner: boolean = true;
  codeProductSearched: string = '';



  constructor(
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private clog: ConsoleService,
    private toastService: ToastService,
    private equivalenciaProductoService: EquivalenciaProductoService,
    private messageRendererService: MessageRendererService,
  ) {
    this.log = this.clog.log('COMPRAS - SELECCIONAR PRODUCTO')

  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());

    this.createForm();

  }

  show() {
    this.seleccionarProductModal.show();
    this.formHeader.get('codeProduct').setValue(null);
    this.formHeader.get('descProduct').setValue(null)

  }

  /********* FORM *********/
  private createForm() {
    this.formHeader = this.fb.group({
      // buscarPor: [this.TIPO_NOMBRE, [Validators.required]],
      // nombre_rut: ['', [Validators.required]]
      codeProduct: [null],
      descProduct: [null],
    });

  }

  Buscar(pageNumber: number) {

    this.Product_paginationContext.CurrentPage = pageNumber

    const inputParams = {
      entidad: {
        empresa_rut: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        cliente_proveedor_rut: parseInt(this.enviaRutProveedor),
        producto_proveedor: this.formHeader.get('codeProduct').value,
        detalle_producto: this.formHeader.get('descProduct').value
      },
      cantidadRegistrosPorPagina: 10, //this.Product_paginationContext.RecordsByPage
      paginaActual: this.Product_paginationContext.CurrentPage
    }
    this.loading = true
    this.loadSpinner = true;
    this.log('inputParams', JSON.stringify(inputParams))

    this.equivalenciaProductoService.obtenerProductoProveedor(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        this.loading = false
        return
      }

      const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta

      this.Product_paginationContext.RecordsCount = totalRegistros
      this.Product_paginationContext.CurrentPage = paginaActual
      this.Product_paginationContext.PagesCount = totalPaginas
      this.showTable = true;
      this.loadSpinner = false;
      this.Productos_lista = registros

      if (registros.length === 0) {
        this.loading = false;
      }
    })
  }


  onPageChange(context: PaginationContext) {
    this.Buscar(context.RequestedPage)
  }

  selectData(producto: any) {

    const codigo = producto
    this.onSelect.emit(codigo)
    this.Productos_lista = [];
    this.hide()
  }

  lastcodeProduct: string = ''

  searchByCodeProduct(codeProduct: string) {
    this.codeProductSearched = codeProduct
    // Query Local
    if (this.lastcodeProduct !== codeProduct) {

      this.lastcodeProduct = codeProduct

      const inputParams = {
        entidad: {
          empresa_rut: this.rutEmpresa,
          sucursal_codigo: this.sucursalCodigo,
          cliente_proveedor_rut: parseInt(this.enviaRutProveedor),
          producto_proveedor: this.lastcodeProduct,
          detalle_producto: null
        },
        paginaActual: this.Product_paginationContext.CurrentPage,
        cantidadRegistrosPorPagina: this.Product_paginationContext.RecordsByPage
      }


      this.equivalenciaProductoService.obtenerProductoProveedor(inputParams, ({ mensajes, respuesta }) => {

        this.handleResultFromOutterSearch(respuesta)
      })
    }
  }

  private handleResultFromOutterSearch({ totalRegistros, registros }) {
    this.log('handleResultFromOutterSearch', { totalRegistros, registros })
    if (totalRegistros === 1) {
      this.removeElementTypename(registros[0])
      this.selectData(registros[0])
    } else {
      this.notFound()
    }
  }

  hide() {
    this.showTable = false;
    this.loading = false
    this.Productos_lista = [];
    this.seleccionarProductModal.hide()
  }

  Close() {
    this.showTable = false;
    this.loading = false
    this.Productos_lista = [];
    this.seleccionarProductModal.hide()
  }

  private removeElementTypename(register: any) {
    delete register.__typename
    return register
  }



  private notFound() {
    this.onNotFound.emit()
  }

}

